import React from "react"
import { Route, Redirect } from "react-router-dom";
import { SessionService } from "../../../services/SessionService";


export const BrokerProtectedRoute = ({children, ...rest}) => {
    return (
        <Route
          {...rest}
          render={({ location }) =>
            SessionService.isBroker() ? 
              children 
              : 
              //TODO: maybe a different page explaining the error? not broker
              <Redirect
                to={{
                  pathname: "/brokerLogin",
                  state: { from: location }
                }}
              />
          }
        />
      );
}